if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        
        this.form.addEventListener('submit', function(e) {
          e.preventDefault();
          this.onSubmitHandler(e);
        }.bind(this));
        
        document.querySelector(".product__custom_subsriptions_new").addEventListener('click', function(e) {
          if (!e.target.classList.contains("button")) {
            return;
          }

          e.target.classList.add('loading');
          e.target.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          this.onSubmitHandler(e);
        }.bind(this));

        document.querySelector(".product__custom_button").addEventListener('click', function(e) {
          this.onSubmitHandler(e, true);
        }.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      
      setUpsellProductQty() {
        let upsellProduct = document.querySelector("[data-upsell]");
        let upsellProductId = upsellProduct.dataset.upsell;
        
        if(upsellProduct) {
          fetch('/cart.js', { method: 'GET', headers: {'Content-Type': 'application/json;'}})
          .then((response) => {
            return response.json();
          }).then((cartObject) => {
            let sum = 0;
            let key = "";
            
            window.theme.cart_total = cartObject.total_price;
            
            cartObject.items.forEach((el) => {
              if(el.id != upsellProductId) { 
                sum = 1;
              }
            });
            
            let updates = '?updates[' + upsellProductId + ']=' + sum;
            
            fetch('/cart/update.js' + updates, {
              method: 'POST'
            }).then(response => {
              this.updateCartContent();
              document.querySelector("cart-drawer-items").dispatchEvent(new Event('cart:refresh'));
              
            }).catch((error) => { });
          });
        }
      }
      
      updateCartContent(event) {
        fetch(window.Shopify.routes.root + "?sections=cart-drawer")
        .then((response) => response.json())
        .then((response) => {
          let selector = "#CartDrawer";
          let drawer = document.querySelector(selector)
          drawer.innerHTML = new DOMParser().parseFromString(response["cart-drawer"], 'text/html').querySelector(selector).innerHTML;
          window.Custom.initSlider(`.drawer__upsell .swiper`);
          window.Custom.setCheckoutUtm();
        });
      }
      
      manageSubsriptionData (formData) {
        let addOptionData = {};
        let addOption = document.querySelector(".additional-option:checked");
        
        let singleProduct = false;
        let annualProduct = false;
        
        if(addOption) {
          addOptionData = JSON.parse(addOption.dataset.details);
          formData.delete('id');
          formData.append('id', addOptionData.variant_id);
          formData.delete('product-id');
          formData.append('product-id', addOptionData.product_id);

          if (addOptionData.selling_plan) {
            formData.delete('selling_plan');
            formData.append('selling_plan', addOptionData.selling_plan);
          }
          
          if(addOptionData.cart_message) {
            formData.delete(`properties[${ window.theme.cart_message }]`);
            formData.append(`properties[${ window.theme.cart_message }]`, addOptionData.cart_message);
          }
          
          if(addOptionData.checkout_message) {
            formData.delete(`properties[${ window.theme.checkout_message }]`);
            formData.append(`properties[${ window.theme.checkout_message }]`, addOptionData.checkout_message);
          }

          if(!addOptionData.selling_plan) {
            singleProduct = true;
            formData.append(`properties[${ window.theme.product_type_key }]`, "Single");
          } else {
            formData.append(`properties[${ window.theme.product_type_key }]`, "Subscription");
          }
          
          if(addOptionData.qty) {
            formData.delete('quantity');
            formData.append('quantity', addOptionData.qty);
          }
        }
        
        return {formDataNew: formData, annualProduct: annualProduct, singleProduct: singleProduct};
      }
        
      onSubmitHandler(evt, skipSub) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          
          this.cart.setActiveElement(document.activeElement);
        }

        if(skipSub) {
          formData.append(`properties[${ window.theme.product_type_key }]`, "Single");
        } else {
          let {formDataNew, annualProduct, singleProduct} = this.manageSubsriptionData(formData);
          formData = formDataNew;
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            
            window.Custom.initSlider(`.drawer__upsell .swiper`);
            window.Custom.cartUpsellAuto();
            window.Custom.setCheckoutUtm();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
